import { render, staticRenderFns } from "./pcbDeltimeTable.vue?vue&type=template&id=51bc381b&scoped=true"
import script from "./pcbDeltimeTable.vue?vue&type=script&lang=js"
export * from "./pcbDeltimeTable.vue?vue&type=script&lang=js"
import style0 from "./pcbDeltimeTable.vue?vue&type=style&index=0&id=51bc381b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc381b",
  null
  
)

export default component.exports